export default __webpack_public_path__ + "static/media/google_logo.39c52b1b.png";